import { createClient } from 'hal-rest-client'
import halConstants from './halConstants.js'

export const linkEntryPoints = {
  infoService: 'itemInfoService',
  availableInfoService: 'availableInfoService',
  rlFwdChartService: 'rlFwdChartService',
  rlRevChartService: 'rlRevChartService',
  ilFwdChartService: 'ilFwdChartService',
  ilRevChartService: 'ilRevChartService',
  pimInfoService: 'pimInfoService',
  pimChartService: 'pimChartService',
  itemOverviewService: 'itemOverviewService'
}

let allServices = null

// https://medium.com/@tiboprea/how-to-fix-internet-explorer-caching-of-ajax-requests-using-angular-5-2c489cf2d1f7
export const client = createClient(halConstants.BASE_PATH, { headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' } })

export async function getResponseFromEntryPoint (entryPointString, params) {
  let returnData
  try {
    // Get the list with all services
    if (!allServices) {
      allServices = await client.fetchResource('/items')
    }
    // Get the desired service
    const serviceResource = allServices.link(entryPointString)
    returnData = await serviceResource.fetch(params)
  } catch (error) {
    returnData = {
      error: getErrorObjectByMessage(error.response)
    }
  }
  return returnData
}

export function createInfoServiceParams (articleId, serialId) {
  return {
    itemNo: articleId,
    serialNo: serialId
  }
}

/**
 * Gets the error object by error message
 * @param message
 */
function getErrorObjectByMessage (response) {
  const status = response ? response.status : '505'
  let errorKey
  switch (status.toString().substring(0, 1)) {
  case '5':
    errorKey = 'hs.att-dashboard.error.5xx'
    break
  default:
    errorKey = 'hs.att-dashboard.error.xxx'
  }
  return {
    errorKey: errorKey,
    status: status
  }
}
